const desktop = theme => {
  const {toVW} = theme;
  return {
    potArea: {
      height: 20,
      width: 120,
      top: '37.5%',
    },
    potInfoContainer: {
      flexDirection: 'row',
      width: '100%',
      justifyContent: 'space-around',
      padding: '0 15px',
    },
  };
};

const mobile = theme => {
  const {toVW} = theme;
  return {
    potArea: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 135,
      height: 40,
      background: 'rgba(70, 69, 77, 0.7)',
      boxShadow: 'inset 3px 3px 5px #000000A5',
      borderRadius: '22px',
      // opacity: '0.7',
      color: 'white',
      border: 'none',
      position: 'absolute',
      textAlign: 'center',
      fontSize: '12px',
      left: '50%',
      transform: 'translate(-50%, 0)',
      // top: '26%',
      top: '31.37%',
      padding: '2px 0',
    },
    potInfoContainer: {
      display: 'flex',
      flexDirection: 'column',
      '& > div': {
        lineHeight: '105%',
      },
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
